import { borderGradient } from "@/containers/GradientContainer/gradientContainerUtils";
import { cn } from "@/lib/utils";
import { Tier as TierType } from "@/redux/players/playersSlice";

export const Tier = ({
  tier,
  basePlayerTier,
}: {
  tier: TierType;
  basePlayerTier?: TierType;
}) => {
  // tier{Border,Color} are Tailwind classes ("border-s-tier-border",
  // "bg-s-tier-background"); strip the prefix back to the token name so the
  // shared gradient-border primitive can paint the ring (accent → transparent)
  // and the interior fill (the semi-transparent tier background).
  const borderToken = tier?.tierBorderColor?.replace("border-", "");
  const fillToken = tier?.tierColor?.replace("bg-", "");
  const gradient = borderToken
    ? borderGradient({ from: borderToken, to: "transparent", fill: fillToken })
    : null;

  // Same tier on both sides is not a transition — show the single tier only.
  const showTransition =
    Boolean(basePlayerTier?.tierName) &&
    basePlayerTier?.tierName !== tier?.tierName;

  return (
    <div
      className={cn(
        "rounded-full h-5 px-1.5 flex items-center justify-center",
        tier?.tierTextColor,
        // When there's no gradient ring (legacy tiers), keep the flat bg class.
        gradient ? gradient.className : tier?.tierColor,
      )}
      style={gradient?.style}
    >
      {showTransition && (
        <>
          <span className={basePlayerTier?.tierTextColor}>
            {basePlayerTier?.tierName}
          </span>
          <TierUpgradeArrow />
        </>
      )}
      {tier?.tierName}
    </div>
  );
};

const TierUpgradeArrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 6H9.75M6.9375 8.8125L9.75 6L6.9375 3.1875"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
